// extracted by mini-css-extract-plugin
module.exports = {"main":"button-panel_main__1M7Bo","btns":"button-panel_btns__39MqD"};